<template>
  <div class="container_plan">
    <transition name="fade" mode="out-in" appear>
      <FormLead :info="true" v-if="show" />
      <div v-if="!show">
        <div>
          <span class="right pointer process3 mt-2 block_process" @click="logout">Logout</span>
        </div>
        <div class="panel pricing-table">
          <div class="pricing-plan" v-for="plan in plans" :key="plan.id">
            <h2 class="pricing-header">{{plan.name}}</h2>
            <div class="pricing-features">
              <li
                class="pricing-features-item center"
              >{{plan.amount_jobs == 1 ? "1 vaga" : plan.amount_jobs+" vagas" }}</li>
              <li
                class="pricing-features-item center"
              >{{plan.amount_recruiters == 1 ? "1 usuário" : plan.amount_recruiters+" usuários" }}</li>
            </div>
            <span class="pricing-price" v-if="plan.price == 0">Free</span>
            <span class="pricing-price" v-if="plan.price > 0">
              R$
              {{ plan.price ? parseFloat(plan.price).toFixed(2).replace('.', ',') : "0,00" }}
            </span>
            <button @click="choose(plan)" class="btn mt-2 btn full btn-primary">
              <span v-show="!load">Sign Up</span>
              <div v-show="load" class="spinner-border text-light" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
            <span v-if="plan.day_free > 0">Free por {{plan.day_free}} dias</span>
          </div>

          <div class="pricing-plan">
            <img class="hide pricing-img" src="https://s21.postimg.cc/tpm0cge4n/space-ship.png" alt />
            <h2 class="pricing-header">Enterprise</h2>
            <div class="pricing-features">
              <li class="pricing-features-item">x vagas</li>
              <li class="pricing-features-item">Candidatos Ilimitados</li>
            </div>
            <span class="pricing-price">Consultar</span>
            <button @click="show = true" class="btn full mt-2 btn-secondary">
              <span v-show="!load">Entre em contato</span>
              <div v-show="load" class="spinner-border text-light" role="status">
                <span class="sr-only"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import FormLead from "@/Leads/Form.vue";
export default {
  components: { FormLead },
  data: () => ({
    load: false,
    show: false,
    plans: [],
  }),
  mounted() {
    axios.get("/payments/plans").then((response) => {
      this.plans = response.data;
    });
  },
  methods: {
    logout() {
      localStorage.removeItem("avatar-url");
      axios
        .delete("/recruiters/sign_out")
        .then((resource) => {
          window.location = "/";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    choose(plan) {
      this.load = true;
      if (plan.price == 0) {
        axios
          .post("/payments/plans/choose_free/" + plan.id)
          .then((response) => {
            this.load = false;
            this.$inertia.visit("/recruiters/dashboard", {
              method: "get",
              data: {},
              replace: true,
              preserveState: false,
              preserveScroll: false,
              only: [],
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$inertia.visit(plan.url_full, {
          method: "get",
          data: {},
          replace: true,
          preserveState: false,
          preserveScroll: false,
          only: [],
        });
      }
    },
  },
};
</script>
